import axios from "axios";
import { errorMessage, tokenExpired } from "@/api/errorMessages";
import * as api from "@/api/oauth";

export default {
  namespaced: true,
  state: {
    standardizeCity: null,
    standardizeZip: null,
    standardizeHuCount: null,
    standardizeDimensions: null,
    standardizeWeight: null,
    infoCityTo: null
  },
  getters: {
    showStandardizeWeight(state) {
      return state.standardizeWeight;
    },
    showInfoCityTo(state) {
      return state.infoCityTo;
    }
  },
  mutations: {
    setStandardizeZip(state, newstandardizeZip) {
      state.standardizeZip = newstandardizeZip;
    },
    setStandardizeCity(state, newstandardizeCity) {
      state.standardizeCity = newstandardizeCity;
    },
    setStandardizeHuCount(state, newstandardizeHuCount) {
      state.standardizeHuCount = newstandardizeHuCount;
    },
    setStandardizeDimensions(state, newstandardizeDimensions) {
      state.standardizeDimensions = newstandardizeDimensions;
    },
    setStandardizeWeight(state, newstandardizeWeight) {
      state.standardizeWeight = newstandardizeWeight;
    },
    setInfoCityTo(state, newInfoCityTo) {
      state.infoCityTo = newInfoCityTo;
    }
  },
  actions: {
    async standardizeZip({ commit }, newZip) {
      const zipCode = newZip.replaceAll(" ", "");
      let info = {};
      info["zip_code"] = zipCode.toString();
      try {
        let response = await axios.post(
          process.env.VUE_APP_BACK_ROUTE +
            `/api/operations/standardize_zip_code/`,
          info,
          api.getToken()
        );
        if (response.status == 200) {
          commit("setStandardizeZip", response.data);
        }
        return response;
      } catch (err) {
        if (err.response.status == 403) {
          tokenExpired();
        } else if (err.response.status != 200) {
          errorMessage();
        }
        return err.response;
      }
    },

    async standardizeCity({ commit }, newCity) {
      let info = {};
      info["city"] = newCity.toString();
      try {
        let response = await axios.post(
          process.env.VUE_APP_BACK_ROUTE + `/api/operations/standardize_city/`,
          info,
          api.getToken()
        );
        if (response.status == 200) {
          commit("setStandardizeCity", response.data);
        }
        return response;
      } catch (err) {
        if (err.response.status == 403) {
          tokenExpired();
        } else if (err.response.status != 200) {
          errorMessage();
        }
        return err.response;
      }
    },

    async standardizeHuCount({ commit }, newHuCount) {
      let info = {};
      info["hu_count"] = newHuCount.toString();
      try {
        let response = await axios.post(
          process.env.VUE_APP_BACK_ROUTE +
            `/api/operations/standardize_hu_count/`,
          info,
          api.getToken()
        );
        if (response.status == 200) {
          commit("setStandardizeHuCount", response.data);
        }
        return response;
      } catch (err) {
        if (err.response.status == 403) {
          tokenExpired();
        } else if (err.response.status != 200) {
          errorMessage();
        }
        return err.response;
      }
    },

    async standardizeDimensions({ commit }, newDimensions) {
      let info = {};
      info["dimensions"] = newDimensions.toString();
      try {
        let response = await axios.post(
          process.env.VUE_APP_BACK_ROUTE +
            `/api/operations/standardize_dimensions/`,
          info,
          api.getToken()
        );
        if (response.status == 200) {
          commit("setStandardizeDimensions", response.data);
        }
        return response;
      } catch (err) {
        if (err.response.status == 403) {
          tokenExpired();
        } else if (err.response.status != 200) {
          errorMessage();
        }
        return err.response;
      }
    },

    async standardizeWeight({ commit }, newWeight) {
      let info = {};
      info["weight"] = newWeight.toString();
      try {
        let response = await axios.post(
          process.env.VUE_APP_BACK_ROUTE +
            `/api/operations/standardize_weight/`,
          info,
          api.getToken()
        );
        if (response.status == 200) {
          commit("setStandardizeWeight", response.data);
        }
        return response;
      } catch (err) {
        if (err.response.status == 403) {
          tokenExpired();
        } else if (err.response.status != 200) {
          errorMessage();
        }
        return err.response;
      }
    }
  }
};
